




import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'ProductFeatures',
  props: {
    container: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    return {
      formattedData: computed(() => props.container.map((item: any) => ({
        id: item.codeId, buttonCta: item.buttonCta, values: item.values.items, image: { src: item.image.filename, alt: item.image.alt },
      }))),
    };
  },
});
